import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentGallery
  extends UmpireComponent<UmpireComponentTypeEnum.GALLERY> {
  images: UmpireImage[];
  images_order: ImagesOrder[];
  layout: 'grid' | 'list';
}

interface ImagesOrder {
  image_id: string;
  image_index: number;
}
